import type { Feature } from '@op/services'
import {
	accountAccess$,
	activeUserHasFeatureCapableDevice$,
	FeatureRequirements,
	fetchAccessState,
	fetchBlockStatuses,
	fetchDevices,
	fetchUsers,
	hasChildren$,
	hasMaxDevices$,
	hasVewCompatibleSKU$,
	isMinPremAccess$,
	rawChildren$,
	unwrapThunks,
} from '@op/services'
import { setGuardModal } from '../reducers/app-misc.slice'
import type { OPThunk, OPThunkP } from '../types'

export const canAddChildUser = (): OPThunkP<boolean> => async (dispatch, getState) => {
	await dispatch(refreshDeviceAndUserData())

	const state = getState()

	return rawChildren$(state).length < (accountAccess$(state).child_users_per_account ?? 20)
}

export const canAddChildDevice = (): OPThunkP<boolean> => async (dispatch, getState) => {
	await dispatch(refreshDeviceAndUserData())

	const state = getState()

	// Historically, code checks if we have children as well.
	return !hasChildren$(state) || !hasMaxDevices$(state)
}

const refreshDeviceAndUserData = (): OPThunkP => async (dispatch) => {
	await Promise.all(
		unwrapThunks([
			dispatch(fetchAccessState()),
			dispatch(fetchBlockStatuses()),
			dispatch(fetchDevices()),
			dispatch(fetchUsers()),
		]),
	)
}

export const canActivateFeature =
	(feature: Exclude<Feature, 'GEO'>): OPThunk<boolean> =>
	(dispatch, getState) => {
		const state = getState()

		const hasSKUAccess = feature == 'VEW' ? hasVewCompatibleSKU$(state) : isMinPremAccess$(state)

		if (!hasSKUAccess || !activeUserHasFeatureCapableDevice$(state, FeatureRequirements[feature])) {
			dispatch(setGuardModal(feature))
			return false
		}

		return true
	}
